import { FInter } from "@brg/ui"
import { LayoutConst } from "core"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import styled, { useTheme } from "styled-components"
import { AppTester } from "supporting"

export interface DesignerRoleProps {
  role: string
  team: string
  city: string
  countryData?: { countryName: string; url: string }
  identifier?: string
  oneLine?: boolean
  onClick?: (identifier: string) => void
  shouldDisplayStudentRole?: boolean
}

const DesignerTeam = styled.span<{ color?: string }>`
  display: inline-flex;
  font-weight: 700;
  color: ${(p) => p?.color};
  cursor: pointer;
  text-transform: uppercase;
  &:hover {
    color: ${({ theme }) => theme.teamLinkHoverAccent};
  }
`
const DesignerCity = styled.span<{ color?: string }>`
  display: inline-flex;
  color: ${(p) => p?.color};

  @media (max-width: ${LayoutConst.screen.md}px) {
  }
`

const RoleText = styled(FInter.TextFlex)<{ inline?: boolean }>`
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  // display: ${(p) => (p?.inline ? "inline-block" : "block")};
  display: flex;
  align-items: center;

  @media (max-width: ${LayoutConst.screen.l}px) {
    // flex-direction: column;
    row-gap: 8px;
    flex-wrap: wrap;
    align-items: start;
    font-size: 13px;
    line-height: 16px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 13px;
    line-height: 16px;
    // white-space: nowrap;
  }

  @media (max-width: ${LayoutConst.screen.xxxsm}px) {
    font-size: 13px;
    line-height: 16px;
    white-space: wrap;
  }
`

const DesignerCountry = styled.div<any>`
  display: flex;
  gap: 8px;
  align-items: start;
  color: ${(p) => p.color || "#151514"};
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.34px;
  padding-right: 8px;
  margin-right: 8px;
  border-right: 1px solid
    ${(p) => (p.showRightBorder ? p.color || "#151514" : "transparent")};

  @media (max-width: ${LayoutConst.screen.l}px) {
    border: none;
    margin-bottom: 4px;
    font-size: 13px;
    line-height: 16px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
  }
`

const CountryName = styled.span`
   @media (max-width: ${LayoutConst.screen.sm}px) {
    white-space: nowrap;
    word-wrap: break-word;
  }
`

const CountryFlag = styled.img`
  width: 29px;
  height: 20px;
  border: 0.4px solid #b6b6b5;
  border-radius: 2px;
`

const RoleName = styled.span`
  font-weight: 400;
  text-transform: none;
  white-space: nowrap;
`

const RoleNameBold = styled.span`
  font-weight: 700;
`

const RoleWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
`

export const DesignerRole: FC<DesignerRoleProps> = (props) => {
  const {
    role,
    team,
    city,
    identifier,
    oneLine,
    onClick,
    countryData,
    shouldDisplayStudentRole,
  } = props
  const theme = useTheme()
  const { t } = useTranslation()

  const showRoleBlock = Boolean(shouldDisplayStudentRole && role?.length)
  const showCreatorakiText = AppTester.isAKI() && role?.toLowerCase?.().includes?.("creatoraki")

  const onTeamClick = () => onClick?.(identifier ?? "")

  return (
    <RoleText color={theme.designerRole} inline={oneLine}>
      {countryData && (
        <DesignerCountry
          color={theme.designerRoleUniversity}
          showRightBorder={shouldDisplayStudentRole && role?.length}
        >
          <CountryFlag src={countryData.url} />
          <CountryName>{countryData.countryName}</CountryName>
        </DesignerCountry>
      )}
      {showRoleBlock ? (
        <>
          <DesignerTeam
            style={{ display: oneLine ? "inline-block" : "inline-flex" }}
            onClick={onTeamClick}
            color={theme.designerRoleUniversity}
          >
            <RoleWrapper>
              {showCreatorakiText ? (
                <>
                  <RoleName>{t("pages.designer.creator_in_aki")}</RoleName>
                  &nbsp;
                  <RoleNameBold>{t("pages.designer.aki")}</RoleNameBold>
                </>
              ) : (
                <RoleName>{role}</RoleName>
              )}
              &nbsp;
              <span>{team}</span>
            </RoleWrapper>
          </DesignerTeam>
          <DesignerCity>{city}</DesignerCity>
        </>
      ) : undefined}
    </RoleText>
  )
}

export default DesignerRole;
import { FInter } from "@brg/ui"
import { LayoutConst } from "core"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import styled, { useTheme } from "styled-components"
import { AppTester } from "supporting"

export interface DesignerRoleProps {
  role: string
  team: string
  city: string
  countryData?: { countryName: string; url: string }
  identifier?: string
  oneLine?: boolean
  onClick?: (identifier: string) => void
  shouldDisplayStudentRole?: boolean
}

const DesignerTeam = styled.span<{ color?: string }>`
  display: inline-flex;
  font-weight: 700;
  color: ${(p) => p?.color};
  cursor: pointer;
  text-transform: uppercase;
  &:hover {
    color: ${({ theme }) => theme.teamLinkHoverAccent};
  }
`
const DesignerCity = styled.span<{ color?: string }>`
  display: inline-flex;
  color: ${(p) => p?.color};

  @media (max-width: ${LayoutConst.screen.md}px) {
  }
`

const RoleText = styled(FInter.TextFlex)<{ inline?: boolean }>`
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  // display: ${(p) => (p?.inline ? "inline-block" : "block")};
  display: flex;
  align-items: center;

  @media (max-width: ${LayoutConst.screen.l}px) {
    // flex-direction: column;
    row-gap: 8px;
    flex-wrap: wrap;
    align-items: start;
    font-size: 13px;
    line-height: 16px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 13px;
    line-height: 16px;
    // white-space: nowrap;
  }

  @media (max-width: ${LayoutConst.screen.xxxsm}px) {
    font-size: 13px;
    line-height: 16px;
    white-space: wrap;
  }
`

const DesignerCountry = styled.div<any>`
  display: flex;
  gap: 8px;
  align-items: start;
  color: ${(p) => p.color || "#151514"};
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.34px;
  padding-right: 8px;
  margin-right: 8px;
  border-right: 1px solid
    ${(p) => (p.showRightBorder ? p.color || "#151514" : "transparent")};

  @media (max-width: ${LayoutConst.screen.l}px) {
    border: none;
    margin-bottom: 4px;
    font-size: 13px;
    line-height: 16px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
  }
`

const CountryName = styled.span`
   @media (max-width: ${LayoutConst.screen.sm}px) {
    white-space: nowrap;
    word-wrap: break-word;
  }
`

const CountryFlag = styled.img`
  width: 29px;
  height: 20px;
  border: 0.4px solid #b6b6b5;
  border-radius: 2px;
`

const RoleName = styled.span`
  font-weight: 400;
  text-transform: none;
  white-space: nowrap;
`

const RoleNameBold = styled.span`
  font-weight: 700;
`

const RoleWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
`

export const DesignerRole: FC<DesignerRoleProps> = (props) => {
  const {
    role,
    team,
    city,
    identifier,
    oneLine,
    onClick,
    countryData,
    shouldDisplayStudentRole,
  } = props
  const theme = useTheme()
  const { t } = useTranslation()

  const showRoleBlock = Boolean(shouldDisplayStudentRole && role?.length)
  const showCreatorakiText = AppTester.isAKI() && role?.toLowerCase?.().includes?.("creatoraki")

  const onTeamClick = () => onClick?.(identifier ?? "")

  return (
    <RoleText color={theme.designerRole} inline={oneLine}>
      {countryData && (
        <DesignerCountry
          color={theme.designerRoleUniversity}
          showRightBorder={shouldDisplayStudentRole && role?.length}
        >
          <CountryFlag src={countryData.url} />
          <CountryName>{countryData.countryName}</CountryName>
        </DesignerCountry>
      )}
      {showRoleBlock ? (
        <>
          <DesignerTeam
            style={{ display: oneLine ? "inline-block" : "inline-flex" }}
            onClick={onTeamClick}
            color={theme.designerRoleUniversity}
          >
            <RoleWrapper>
              {showCreatorakiText ? (
                <>
                  <RoleName>{t("pages.designer.creator_in_aki")}</RoleName>
                  &nbsp;
                  <RoleNameBold>{t("pages.designer.aki")}</RoleNameBold>
                </>
              ) : (
                <RoleName>{role}</RoleName>
              )}
              &nbsp;
              <span>{team}</span>
            </RoleWrapper>
          </DesignerTeam>
          <DesignerCity>{city}</DesignerCity>
        </>
      ) : undefined}
    </RoleText>
  )
}

export default DesignerRole;
